import { elementSettings as sdkElementSettings } from '@yola/ws-sdk';
import Context from './helpers/element-settings-context';
import components from './components';
import stages from './constants/stages';
import helpers from './helpers';
import hooks from './hooks';

export default {
  Context,
  components,
  constants: {
    triggerTypes: sdkElementSettings.constants.triggerTypes,
    stages,
  },
  filters: sdkElementSettings.filters,
  helpers,
  hooks,
};
